import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar14Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar14 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar14Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar14">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <G id="Group_2">
            <Path
              id="skin"
              d="M170 50.997c-77.974-1.096-60.379 77.625-60.18 79.936-9.302-7.578-23.592-.429-18.477 20.01 8.706 34.817 26.389 25.507 33.443 20.471 2.534 5.949-5.934 47.177-6.697 54.151-2.081 19.08-20.582 25.634-20.582 25.634s37.573 37.915 77.792 50.712a150.501 150.501 0 0 0 23.918-5.624c2.701-14.164 2.256-40.822-18.35-44.929-3.241-.644-.31-21.766.358-33.538 8.237 1.565 18.032 4.027 24.299-2.24 6.522-13.663 20.502-40.703 21.193-52.674.445-7.745-.881-10.668-.881-24.863.683-46.248-18.755-86.53-55.844-87.054l.008.008Z"
              fill={c.skin}
            />
            <Path
              id="Vector"
              opacity={0.75}
              d="M179.255 236.892c.754-6.919 2.653-19.112 2.24-19.199-22.29-4.981-36.874-14.124-42.181-19.041 0 .453 12.702 32.727 39.941 38.24Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_2"
              opacity={0.75}
              d="M174.195 180.453c.699.85 10.232 16.102 22.155 16.467 10.16.31 14.322-11.343 14.608-11.931 0 0-4.091-5.465-7.212-5.561-3.122-.095-5.434 1.581-5.434 1.581s-2.653-2.216-5.966-2.319c-3.312-.104-6.41 1.747-9.556 2.137-3.177.397-8.602-.374-8.602-.374h.007Zm4.107 2.629c-.079-.063 0-.174.096-.127 3.662 1.915 10.151 3.511 20.359 3.821 5.259.159 8.746.215 11.701-.715-2.963 1.2-7.022 4.735-12.273 4.576-10.239-.31-16.316-4.87-19.891-7.562l.008.007Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_3"
              opacity={0.75}
              d="M191.098 167.426c-.604 2.351 2.304 3.908 12.281 3.511 8.214-.326 10.867-4.782 9.254-5.409-1.612-.628-3.773 2.176-9.119 2.176-7.801 0-11.804-2.629-12.408-.278h-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_4"
              d="M144.685 126.914s12.765-4.012 22.694-3.94c11.669.087 19.859 7.896 22.107 3.9.715-1.271.231-7.952-21.034-10.136-9.517-.977-15.117 3.487-23.767 10.184v-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_5"
              d="M185.41 142.316c-2.876-4.917-7.65-9.452-13.639-10.549-2.701-.317-5.426-.016-7.991.985-2.097.803-3.718 2.129-5.275 3.464-2.113 1.461-4.909.905-7.443.603 2.399 1.677 5.942 3.019 8.857 1.581a27.27 27.27 0 0 1 2.026-1.183c-.016.214-.04.421-.04.635 0 3.908 3.281 7.086 7.324 7.086 4.043 0 7.324-3.17 7.324-7.086 0-.318-.032-.635-.072-.945 2.868 1.319 5.76 3.265 8.929 5.409Z"
              fill="#000"
            />
            <Path
              id="Vector_6"
              d="M224.74 119.884c-13.949-.421-21.98 7.316-20.486 10.191.929 1.78 3.773 1.851 5.87-.159 5.759-4.94 9.191-3.288 15.22-3.368-.111-2.105-.413-4.909-.612-6.664h.008Z"
              fill="#000"
            />
            <G id="Group_3" fill="#000">
              <Path
                id="Vector_7"
                d="M98.366 250.627c-16.666 3.329-34.054 8.603-47.042 14.998 26.778 23.672 61.96 38.042 100.51 38.042 7.729 0 15.323-.58 22.743-1.7-30.504-11.225-70.158-45.938-76.211-51.34Z"
              />
              <Path
                id="Vector_8"
                d="M240.976 274.554a22.407 22.407 0 0 0-2.248-1.772c-10.891-7.467-32.497-17.587-61.539-22.695.222.588 3.36 3.472 3.725 3.551 20.058 4.155 20.272 29.741 17.468 43.722 15.451-5.211 29.797-12.972 42.586-22.806h.008Z"
              />
            </G>
            <Path
              id="hair"
              d="M154.407 42.64c-15.156-4.837-54.135-1.707-77.672 45.692-18.62 37.502-28.978 132.563-32.489 170.628a152.967 152.967 0 0 0 12.098 10.907c20.383-8.103 57.027-23.577 60.038-31.219 4.194-10.636 10.541-60.871 8.738-67.131-.493-1.715-22.886 21.488-33.673-22.337-5.029-12.71 9.699-39.019 32.441 1.851 2.614 4.702 4.385-24.157 3.623-25.57-.763-1.414 16.872-7.785 26.007-21.599 9.135-13.806 14.616-23.14 32.894-30.757-.421-3.432-11.51-17.897-11.51-17.897s52.332 29.113 50.624 80.087c-.691 17.245.064 21.002-.453 28.517-1.644 7.801-17.15 45.707-21.026 51.458-3.869 5.752-22.814 2.503-22.814 2.503l-4.004 32.314 55.391 30.329a154.905 154.905 0 0 0 6.458-4.298c2.224-10.461 5.147-32.688.04-65.034 9.746-45.993 8.531-184.592-84.679-168.451l-.032.008Z"
              fill={c.hair}
            />
            <Path
              id="Vector_9"
              d="M230.776 138.75c-1.557-1.327-3.169-2.661-5.274-3.464-2.566-.993-5.298-1.302-7.991-.985-5.99 1.097-10.756 5.632-13.639 10.549 1.628-1.096 3.185-2.152 4.694-3.09.278 3.44 3.249 6.149 6.879 6.149 3.813 0 6.911-2.987 6.911-6.681a6.391 6.391 0 0 0-1.001-3.416c2.471.278 5.092 1.232 8.007 3.114 2.916 1.438 6.459.096 8.858-1.58-2.534.293-5.339.85-7.444-.604v.008Z"
              fill="#000"
            />
            <Path
              id="Vector_10"
              d="M199.32 120.837c1.404 0 2.542-1.707 2.542-3.813s-1.138-3.813-2.542-3.813-2.542 1.707-2.542 3.813 1.138 3.813 2.542 3.813Z"
              fill="#000"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
